import { RouteObject, useRoutes } from 'react-router-dom';
import { routes as moduleRoutes } from '@sidecar/modules';

const routes: RouteObject[] = [...moduleRoutes];

const Routes = () => {
  const children = useRoutes(routes);

  return children;
};

export default Routes;
